import * as THREE from 'three';
import { global } from '../../core/GlobalState';
//todo make in not move the player if they are within r of the orb portal. I also want to split this into warp and warp + enter
export function warpToPoint(after) {
    var _a, _b, _c;
    if (global.warpInProgress || !((_a = global.currentObject) === null || _a === void 0 ? void 0 : _a.parent)) {
        after === null || after === void 0 ? void 0 : after(); // still call after() to not strand callers
        return;
    }
    const targetOrb = global.orbManager.getOrb(global.currentObject.parent.uuid);
    if (!targetOrb || !targetOrb.group) {
        after === null || after === void 0 ? void 0 : after();
        return;
    }
    const startPos = global.camera.position.clone();
    const cameraDir = new THREE.Vector3();
    global.camera.getWorldDirection(cameraDir).normalize();
    const orbPosition = targetOrb.group.position.clone();
    const radius = (_c = (_b = targetOrb.orbConfig) === null || _b === void 0 ? void 0 : _b.radius) !== null && _c !== void 0 ? _c : 100;
    const hoverDistance = radius * 1.3;
    const targetPos = orbPosition.clone().sub(cameraDir.multiplyScalar(hoverDistance));
    global.warpInProgress = true;
    animateWarp(startPos, targetPos, 1000, () => {
        global.warpInProgress = false;
        after === null || after === void 0 ? void 0 : after(); // <- invoke when finished
    });
}
export function animateWarp(start, end, duration, onComplete) {
    const startTime = performance.now();
    const animate = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        const eased = t * t * (3 - 2 * t);
        const pos = start.clone().lerp(end, eased);
        global.camera.position.copy(pos);
        global.controls.getObject().position.copy(pos);
        if (t < 1)
            requestAnimationFrame(animate);
        else
            onComplete();
    };
    requestAnimationFrame(animate);
}
